export default {
    SET_CURRENT_USER: "USER/SET_USER",
    UPDATE_CURRENT_USER: "USER/UPDATE_USER",
    REMOVE_CURRENT_USER: "USER/REMOVE_USER",
    SET_USERS_LIST: "USER/SET_LIST",
    PUSH_USERS: "USER/PUSH_USERS",
    CLEAR_USERS_LIST: "USER/CLEAR_LIST"
}
